import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import SuperAdminDashboard from './Dashboard';
import CompanyAdminsList from './CompanyAdminsList';
import CompanyAdminDetails from './CompanyAdminDetails';
import CreateCompanyAdmin from './CreateCompanyAdmin';
import Settings from './Settings';

const SuperAdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<SuperAdminDashboard />} />
      <Route path="/company-admins" element={<CompanyAdminsList />} />
      <Route path="/company-admins/new" element={<CreateCompanyAdmin />} />
      <Route path="/company-admins/:id" element={<CompanyAdminDetails />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="*" element={<Navigate to="/superadmin" replace />} />
    </Routes>
  );
};

export default SuperAdminRoutes;
